import { createSlice } from "@reduxjs/toolkit";
import type { LDFlagChangeset, LDFlagSet } from "launchdarkly-js-client-sdk";
import { getFlattenedFlagsFromChangeset, camelCaseKeys } from "launchdarkly-react-client-sdk/lib/utils";

export interface FeatureFlags {
  newNav: boolean;
  streamingUpload: boolean;
  localRecordingMimeType: string;
  localVideoRecordingBitrate: number;
  localVideoMaxResolution: { width: number; height: number };
  disableAutomaticResolutionSwitching: boolean;
  shareLink: boolean;
  transcriptVersions: boolean;
  transcriptLayout: boolean;
  newVideoList: boolean;
  enableCredits: boolean;
  enableWhisper: boolean;
  newFeatureUi: boolean;
  enableChatGpt: boolean;
  enableSpeechmaticsAutochaptering: boolean;
  enableHubPage: boolean;
  enableTwilioVideo: boolean;
  deepgramTranscription: boolean;
  enableNewConclude: boolean;
  enableOrgBranding: boolean;
  enableHypothesis: boolean;
  enableNewMarketingSite: boolean;
  videoCallProviderSelection: string;
  enableAiSettings: boolean;
  publicPages: boolean;
  enableSharedGalleries: boolean;
  enableRemixer: boolean;
  automaticTranscode: boolean;
  enableGalleryClips: boolean;
  enableEntities: boolean;
  enableOrgLevelMfa: boolean;
  enableSemanticSearch: boolean;
  enableAskTheArchive: boolean;
}

export interface FeatureFlagState {
  loaded: boolean;
  flags?: FeatureFlags;
}

const initialState: FeatureFlagState = {
  loaded: false,
};

const slice = createSlice({
  name: "featureFlags",
  initialState,
  reducers: {
    loaded(state, { payload }: { payload: FeatureFlags }) {
      state.loaded = true;
      state.flags = camelCaseKeys(payload) as FeatureFlags;
    },
    flagsUpdated(state, { payload }: { payload: LDFlagChangeset }) {
      const flattened: LDFlagSet = camelCaseKeys(getFlattenedFlagsFromChangeset(payload, null));
      if (Object.keys(flattened).length > 0) {
        state.flags = { ...state.flags, ...flattened };
      }
    },
  },
});

export const { loaded, flagsUpdated } = slice.actions;
export default slice.reducer;
